export enum FirebaseAuthAction {
  forgotPassword = 'forgotPassword',
  resetPassword = 'resetPassword',
  verifyAndChangeEmail = 'verifyAndChangeEmail',
}
